/* TAVERN GLASS 3.0 - additive behaviours. No dependencies, no Dawn overrides.
   1) html.tg-top while the page is scrolled to (near) the top
   2) product rails: arrows, snap step, polite autoplay
   3) reveal-on-scroll (self-removing; disabled under reduced motion) */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- 1 · top-of-page state for the glass pill --- */
  function setTop() {
    document.documentElement.classList.toggle('tg-top', window.scrollY < 30);
  }
  setTop();
  window.addEventListener('scroll', setTop, { passive: true });

  /* legibility scrim element (only when the transparent-at-top mode is on) */
  if (document.body.classList.contains('tavern-glasstop')) {
    var scrim = document.createElement('div');
    scrim.className = 'tg-scrim';
    scrim.setAttribute('aria-hidden', 'true');
    document.body.appendChild(scrim);
  }

  /* --- 2 · rails --- */
  document.querySelectorAll('[data-tavern-rail]').forEach(function (rail) {
    var track = rail.querySelector('.tavern-rail__track');
    if (!track) return;
    var prev = rail.querySelector('.tavern-rail__btn--prev');
    var next = rail.querySelector('.tavern-rail__btn--next');

    function step() {
      var card = track.firstElementChild;
      return card ? card.offsetWidth + 18 : Math.round(track.clientWidth * 0.7);
    }
    function arrows() {
      if (!prev || !next) return;
      prev.toggleAttribute('disabled', track.scrollLeft < 8);
      next.toggleAttribute('disabled',
        track.scrollLeft > track.scrollWidth - track.clientWidth - 8);
    }
    if (prev) prev.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: 'smooth' }); hold(8000);
    });
    if (next) next.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: 'smooth' }); hold(8000);
    });
    track.addEventListener('scroll', arrows, { passive: true });
    arrows();

    /* autoplay: one card at a time, wraps, pauses on hover/touch/manual */
    var ms = reduced ? 0 : parseInt(rail.dataset.autoplay || '0', 10);
    var holdUntil = 0;
    function hold(t) { holdUntil = Date.now() + t; }
    if (ms > 0) {
      setInterval(function () {
        if (Date.now() < holdUntil) return;
        if (document.hidden) return;
        var atEnd = track.scrollLeft > track.scrollWidth - track.clientWidth - 8;
        if (atEnd) track.scrollTo({ left: 0, behavior: 'smooth' });
        else track.scrollBy({ left: step(), behavior: 'smooth' });
      }, ms);
      rail.addEventListener('mouseenter', function () { holdUntil = Infinity; });
      rail.addEventListener('mouseleave', function () { hold(1500); });
      rail.addEventListener('touchstart', function () { hold(9000); }, { passive: true });
      rail.addEventListener('focusin', function () { holdUntil = Infinity; });
      rail.addEventListener('focusout', function () { hold(1500); });
    }
  });

  /* --- 3 · reveal-on-scroll --- */
  if (!reduced && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('tg-in');
        io.unobserve(e.target);
        e.target.addEventListener('transitionend', function () {
          e.target.classList.remove('tg-reveal', 'tg-in');
        }, { once: true });
      });
    }, { threshold: 0.15 });
    document.querySelectorAll(
      '.tavern-sec-head, .tavern-cat, .tavern-note, .tavern-room, .tavern-guild, ' +
      '.tavern-orig > div, .tavern-rail__track > *'
    ).forEach(function (el, i) {
      el.classList.add('tg-reveal');
      el.style.transitionDelay = (i % 4) * 70 + 'ms';
      io.observe(el);
    });
  }
})();

/* --- 4 · mega menu rails: category > game > army group --- */
(function () {
  'use strict';
  /* One tab stop per rail (the ARIA tab pattern): only the selected item is
     tabbable, arrow keys move inside the rail, so Tab leaves the rail for the
     cards. Without it Tab walks every tab and swaps the panel underneath, which
     leaves all but the last group's cards unreachable from the keyboard. */
  function roving(items) {
    var sel = null;
    items.forEach(function (el) { if (el.classList.contains('on')) sel = el; });
    if (!sel) sel = items[0];
    items.forEach(function (el) { el.setAttribute('tabindex', el === sel ? '0' : '-1'); });
  }
  function arrows(items, pick) {
    items.forEach(function (el, i) {
      el.addEventListener('keydown', function (e) {
        var to = null;
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { to = items[(i + 1) % items.length]; }
        else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { to = items[(i - 1 + items.length) % items.length]; }
        else if (e.key === 'Home') { to = items[0]; }
        else if (e.key === 'End') { to = items[items.length - 1]; }
        if (!to) return;
        e.preventDefault();
        pick(to);
        to.focus();
      });
    });
  }
  /* The pane wrapper only holds a fixed height while it glides from one pane's
     height to the next; afterwards the height goes back to the content (auto), so
     pictures, fonts or a width change can never leave the menu cut off. A closed
     menu is never measured: its hidden cards measure almost nothing, and a fixed
     height taken then would clip the menu the next time it opens. markFrom reads
     the start height just before a pane switch; syncOne glides to the new height. */
  function releaseNow(wrap) {
    clearTimeout(wrap._gmRelease);
    wrap._gmRelease = null;
    wrap._gmFrom = null;
    wrap.style.height = '';
  }
  function isOpen(wrap) {
    var menu = wrap.closest('details');
    return !menu || menu.hasAttribute('open');
  }
  function markFrom(wrap) {
    if (!wrap || wrap._gmFrom != null || !isOpen(wrap)) return;
    wrap._gmFrom = wrap.getBoundingClientRect().height;
  }
  function syncOne(wrap) {
    if (!wrap) return;
    var active = wrap.querySelector('[data-gm-pane].on');
    if (!active || !isOpen(wrap)) { releaseNow(wrap); return; }
    var to = active.offsetHeight;
    var from = wrap._gmFrom;
    wrap._gmFrom = null;
    if (!to) { releaseNow(wrap); return; }
    if (from != null) {
      if (Math.abs(from - to) < 1 && !wrap._gmRelease) { wrap.style.height = ''; return; }
      wrap.style.height = from + 'px';
      void wrap.offsetHeight; /* commit the start height so the change can glide */
    } else if (!wrap._gmRelease) {
      wrap.style.height = '';
      return;
    }
    wrap.style.height = to + 'px';
    clearTimeout(wrap._gmRelease);
    wrap._gmRelease = setTimeout(function () {
      wrap._gmRelease = null;
      wrap.style.height = '';
    }, 320);
  }
  function initGm(root) {
    (root || document).querySelectorAll('.gm-panel2:not([data-gm-init])').forEach(function (panel) {
      panel.dataset.gmInit = '1';
      /* :has() fallback: mark card grids that hold a group rail so the wrapper
         switches to block layout in browsers without :has() support */
      panel.querySelectorAll('.gm-grid--pane').forEach(function (grid) {
        for (var i = 0; i < grid.children.length; i++) {
          if (grid.children[i].classList && grid.children[i].classList.contains('gm-sub')) {
            grid.classList.add('gm-grid--block');
            break;
          }
        }
      });
      var tabs = [].slice.call(panel.querySelectorAll('[data-gm-tab]'));
      var panes = [].slice.call(panel.querySelectorAll('[data-gm-pane]'));
      var panesWrap = panel.querySelector('.gm-panes');
      function syncHeight() { syncOne(panesWrap); }
      /* opening the menu always starts from the content's own height */
      var menuDetails = panel.closest('details');
      if (menuDetails && panesWrap) {
        menuDetails.addEventListener('toggle', function () { releaseNow(panesWrap); });
      }
      function activateGroup(wrap, id) {
        markFrom(panesWrap);
        var items = [].slice.call(wrap.querySelectorAll('[data-gm-sgroup]'));
        items.forEach(function (b) {
          var on = b.dataset.gmSgroup === id;
          b.classList.toggle('on', on);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        wrap.querySelectorAll('[data-gm-spane]').forEach(function (p) {
          p.classList.toggle('on', p.dataset.gmSpane === id);
        });
        roving(items);
        syncHeight();
      }
      function activateGame(pane, id) {
        markFrom(panesWrap);
        var games = [].slice.call(pane.querySelectorAll('[data-gm-game]'));
        games.forEach(function (g) {
          var on = g.dataset.gmGame === id;
          g.classList.toggle('on', on);
          g.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        pane.querySelectorAll('[data-gm-gpane]').forEach(function (gp) {
          gp.classList.toggle('on', gp.dataset.gmGpane === id);
        });
        roving(games);
        syncHeight();
      }
      function activate(id) {
        markFrom(panesWrap);
        tabs.forEach(function (t) {
          var on = t.dataset.gmTab === id;
          t.classList.toggle('on', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panes.forEach(function (p) {
          var on = p.dataset.gmPane === id;
          p.classList.toggle('on', on);
          if (on && !p.querySelector('[data-gm-game].on')) {
            var first = p.querySelector('[data-gm-game]');
            if (first) activateGame(p, first.dataset.gmGame);
          }
        });
        roving(tabs);
        syncHeight();
      }
      syncHeight();
      var railT;
      tabs.forEach(function (t) {
        t.addEventListener('mouseenter', function () {
          clearTimeout(railT);
          railT = setTimeout(function () { activate(t.dataset.gmTab); }, 90);
        });
        t.addEventListener('mouseleave', function () { clearTimeout(railT); });
        t.addEventListener('focus', function () { activate(t.dataset.gmTab); });
        t.addEventListener('click', function (e) {
          if (t.dataset.gmLeaf !== '1') {
            e.preventDefault();
            activate(t.dataset.gmTab);
          }
        });
      });
      if (tabs.length) {
        roving(tabs);
        arrows(tabs, function (el) { activate(el.dataset.gmTab); });
      }
      var grailT;
      panes.forEach(function (pane) {
        var games = [].slice.call(pane.querySelectorAll('[data-gm-game]'));
        games.forEach(function (g) {
          g.addEventListener('mouseenter', function () {
            clearTimeout(grailT);
            grailT = setTimeout(function () { activateGame(pane, g.dataset.gmGame); }, 90);
          });
          g.addEventListener('mouseleave', function () { clearTimeout(grailT); });
          g.addEventListener('focus', function () { activateGame(pane, g.dataset.gmGame); });
          g.addEventListener('click', function () { activateGame(pane, g.dataset.gmGame); });
        });
        if (games.length) {
          roving(games);
          arrows(games, function (el) { activateGame(pane, el.dataset.gmGame); });
        }
      });
      /* third tier: army group rail inside a game pane. Same hover-intent and
         click-always-works rules as the rails above it. */
      var srailT;
      panel.querySelectorAll('.gm-sub').forEach(function (wrap) {
        var items = [].slice.call(wrap.querySelectorAll('[data-gm-sgroup]'));
        items.forEach(function (s) {
          s.addEventListener('mouseenter', function () {
            clearTimeout(srailT);
            srailT = setTimeout(function () { activateGroup(wrap, s.dataset.gmSgroup); }, 90);
          });
          s.addEventListener('mouseleave', function () { clearTimeout(srailT); });
          s.addEventListener('focus', function () { activateGroup(wrap, s.dataset.gmSgroup); });
          s.addEventListener('click', function () { activateGroup(wrap, s.dataset.gmSgroup); });
        });
        if (items.length) {
          roving(items);
          arrows(items, function (el) { activateGroup(wrap, el.dataset.gmSgroup); });
        }
      });
    });
  }
  initGm();
  /* the editor re-renders the header section on every setting change; without
     this the fresh rails carry no listeners and their panes cannot be opened */
  document.addEventListener('shopify:section:load', function (e) { initGm(e.target); });
  window.addEventListener('resize', function () {
    document.querySelectorAll('.gm-panel2 .gm-panes').forEach(syncOne);
  });
})();

/* --- 5 · hover-open dropdowns (research: 120ms intent delay) --- */
(function () {
  'use strict';
  var nav = document.querySelector('.header__inline-menu');
  if (!nav || nav.dataset.gmHover === 'false') return;
  if (window.matchMedia('(hover: none)').matches) return; /* touch: keep tap */
  nav.querySelectorAll('header-menu > details').forEach(function (d) {
    var openT, closeT;
    var wrap = d.parentElement;
    wrap.addEventListener('mouseenter', function () {
      clearTimeout(closeT);
      openT = setTimeout(function () {
        d.setAttribute('open', '');
        var s = d.querySelector('summary');
        if (s) s.setAttribute('aria-expanded', 'true');
      }, 120);
    });
    wrap.addEventListener('mouseleave', function () {
      clearTimeout(openT);
      closeT = setTimeout(function () {
        d.removeAttribute('open');
        var s = d.querySelector('summary');
        if (s) s.setAttribute('aria-expanded', 'false');
      }, 260);
    });
  });
})();

/* --- 6 · mobile tavern menu accordions (independent of Dawn drawer JS) --- */
(function () {
  'use strict';
  function gmToggle(e) {
    var btn = e.target.closest('.gm-m__toggle');
    if (!btn) return;
    if (e.type === 'keydown' && e.key !== ' ' && e.key !== 'Enter') return;
    e.preventDefault();
    e.stopPropagation();
    var holder = btn.closest('.gm-m__grp') || btn.closest('.gm-m__game') || btn.closest('.gm-m__cat') || btn.closest('.gm-m__top');
    if (!holder) return;
    var open = holder.classList.toggle('open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  document.addEventListener('click', gmToggle);
  document.addEventListener('keydown', gmToggle);
})();

/* --- 7 · countdown (re-inits on editor re-render) --- */
(function () {
  'use strict';
  function initCounts(root) {
  (root || document).querySelectorAll('.tavern-count[data-end]:not([data-tg-init])').forEach(function (el) {
    el.dataset.tgInit = '1';
    var raw = (el.dataset.end || '').trim().replace(' ', 'T');
    var end = new Date(raw);
    if (isNaN(end)) return;
    var u = { d: el.querySelector('[data-u="d"]'), h: el.querySelector('[data-u="h"]'),
              m: el.querySelector('[data-u="m"]'), s: el.querySelector('[data-u="s"]') };
    var done = el.querySelector('.tavern-count__done');
    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) {
        el.classList.add('expired');
        if (done) done.hidden = false;
        clearInterval(t);
        return;
      }
      var s = Math.floor(diff / 1000);
      u.d.textContent = Math.floor(s / 86400);
      u.h.textContent = String(Math.floor(s % 86400 / 3600)).padStart(2, '0');
      u.m.textContent = String(Math.floor(s % 3600 / 60)).padStart(2, '0');
      u.s.textContent = String(s % 60).padStart(2, '0');
    }
    tick();
    var t = setInterval(tick, 1000);
  });
  }
  initCounts();
  document.addEventListener('shopify:section:load', function (e) { initCounts(e.target); });
})();

/* --- 8 · tally count-up --- */
(function () {
  'use strict';
  var els = document.querySelectorAll('[data-tally]');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      io.unobserve(en.target);
      var raw = en.target.textContent.trim();
      var m = raw.match(/^(\d[\d,]*)(.*)$/);
      if (!m) return;
      var target = parseInt(m[1].replace(/,/g, ''), 10);
      var suffix = m[2] || '';
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / 1400, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        en.target.textContent = Math.round(target * eased).toLocaleString() + suffix;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) { io.observe(el); });
})();

/* --- 9 · before/after slider (delegated: survives editor re-renders) --- */
(function () {
  'use strict';
  document.addEventListener('input', function (e) {
    if (!e.target.classList || !e.target.classList.contains('tavern-ba__range')) return;
    var el = e.target.closest('.tavern-ba');
    if (el) el.style.setProperty('--tg-ba', e.target.value + '%');
  });
})();

/* --- 10 · product gallery autoplay + BA thumbnail focus --- */
(function () {
  'use strict';
  var section = document.querySelector('section.product, .product');
  var gallery = document.querySelector('[id^="MediaGallery-"]');
  if (!gallery) return;
  var cfg = document.querySelector('[data-tg-gallery]');
  var viewer = gallery.querySelector('[id^="GalleryViewer-"]');
  var list = viewer ? viewer.querySelector('ul') : null;
  if (cfg && list && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var interval = parseInt(cfg.dataset.tgInterval || '5', 10) * 1000;
    var idx = 0, timer = null, stopped = false;
    function slides() { return Array.prototype.slice.call(list.querySelectorAll('li.product__media-item')); }
    function advance() {
      var s = slides();
      if (s.length < 2) return;
      idx = (idx + 1) % s.length;
      list.scrollTo({ left: s[idx].offsetLeft, behavior: 'smooth' });
    }
    function start() { if (!stopped && !timer) timer = setInterval(advance, interval); }
    function pause() { clearInterval(timer); timer = null; }
    function stop() { stopped = true; pause(); }
    gallery.addEventListener('pointerenter', pause);
    gallery.addEventListener('pointerleave', function () { if (!stopped) start(); });
    gallery.addEventListener('pointerdown', stop);
    gallery.addEventListener('keydown', stop);
    start();
  }
  /* BA lead: activate the comparison on landing, but YIELD to variant
     selection - an explicit ?variant= URL or any later variant change
     keeps Dawn in charge of the viewer */
  function baLead() {
    if (/[?&]variant=/.test(location.search)) return;
    var slide = gallery.querySelector('li[data-tg-ba-lead]');
    if (!slide || slide.classList.contains('is-active')) return;
    gallery.querySelectorAll('[data-media-id]').forEach(function (el) { el.classList.remove('is-active'); });
    slide.classList.add('is-active');
    gallery.querySelectorAll('.thumbnail[aria-current]').forEach(function (b) { b.removeAttribute('aria-current'); });
    var thumbLi = gallery.querySelector('li[data-target$="-tavernba"] button');
    if (thumbLi) thumbLi.setAttribute('aria-current', 'true');
    if (list) list.scrollTo({ left: slide.offsetLeft });
  }
  baLead();
  document.addEventListener('shopify:section:load', baLead);

  /* BA thumbnail: Dawn binds it via data-target; this fallback mimics
     setActiveMedia in case bindings ran before our slide existed */
  gallery.addEventListener('click', function (e) {
    var thumbLi = e.target.closest('li[data-target$="-tavernba"]');
    if (!thumbLi) return;
    var mediaId = thumbLi.dataset.target;
    var slide = gallery.querySelector('[data-media-id="' + mediaId + '"]');
    if (!slide) return;
    setTimeout(function () {
      if (slide.classList.contains('is-active')) return; /* Dawn handled it */
      gallery.querySelectorAll('[data-media-id]').forEach(function (el) { el.classList.remove('is-active'); });
      slide.classList.add('is-active');
      gallery.querySelectorAll('.thumbnail[aria-current]').forEach(function (b) { b.removeAttribute('aria-current'); });
      var btn = thumbLi.querySelector('button');
      if (btn) btn.setAttribute('aria-current', 'true');
      if (list) list.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      window.dispatchEvent(new Event('resize')); /* let Dawn recalc slider state */
    }, 60);
  });
})();

/* ------------------------------------------------------------
   Clamp: collection descriptions fold to a few lines with a
   Read more toggle; the button hides when nothing overflows
   ------------------------------------------------------------ */
(function () {
  function initClamps(root) {
    (root || document).querySelectorAll('.tavern-clamp').forEach(function (c) {
      var body = c.querySelector('.tavern-clamp__body');
      var btn = c.querySelector('.tavern-clamp__btn');
      if (!body || !btn) return;
      if (!c.classList.contains('open')) {
        btn.hidden = body.scrollHeight <= body.clientHeight + 2;
      }
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.tavern-clamp__btn');
    if (!btn) return;
    var c = btn.closest('.tavern-clamp');
    if (!c) return;
    c.classList.toggle('open');
    btn.textContent = c.classList.contains('open') ? (btn.dataset.less || 'Read less') : (btn.dataset.more || 'Read more');
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initClamps(document); });
  } else {
    initClamps(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initClamps(e.target); });
  window.addEventListener('resize', function () { initClamps(document); });
})();

/* ------------------------------------------------------------
   Live search panel. Rules of this module, per the UX audit:
   - chip state changes ONLY on a user action (click chip, Clear,
     Escape, or the explicit "Search all products" button); code
     never silently drops a scope
   - a scoped search with no matches keeps the scope lit and says
     so, offering the broader search as a button
   - the visible status line is also the aria-live announcement
   - queries ride the predictive engine (matches from the first
     letter); scoped queries of 5+ letters use the page engine so
     storefront tag filters apply server-side; the client tag
     check runs on both as the guarantee
   ------------------------------------------------------------ */
(function () {
  var AUX = 'tavern-showcase-grid';

  function stash(box) {
    if (box.__tgStash) return;
    var grid = box.querySelector('[data-tavern-live-grid]');
    var h = box.querySelector('[data-live-heading]');
    var va = box.querySelector('[data-live-viewall]');
    box.__tgStash = {
      grid: grid ? grid.innerHTML : '',
      heading: h ? h.textContent : '',
      view: va ? va.getAttribute('href') : ''
    };
  }
  function setStatus(box, text) {
    var s = box.querySelector('[data-live-status]');
    if (s) s.textContent = text || '';
  }
  function restore(box) {
    var s = box.__tgStash;
    if (!s) return;
    var grid = box.querySelector('[data-tavern-live-grid]');
    if (grid) grid.innerHTML = s.grid;
    var h = box.querySelector('[data-live-heading]');
    if (h) h.textContent = s.heading;
    var va = box.querySelector('[data-live-viewall]');
    if (va && s.view) va.setAttribute('href', s.view);
    setStatus(box, '');
    box.classList.remove('is-loading');
  }
  /* a chip scopes by the store's own truth: membership of the collection
     it links to; the optional scope tags widen the match */
  function scopeOf(chip) {
    if (!chip) return null;
    var handle = chip.dataset.scopeHandle || '';
    var tags = chip.dataset.scopeTag
      ? chip.dataset.scopeTag.toLowerCase().split(',').map(function (t) { return t.trim(); })
      : [];
    if (!handle && !tags.length) return null;
    return { handle: handle, tags: tags };
  }
  function matches(li, scope) {
    if (scope.handle) {
      var cols = (li.getAttribute('data-collections') || '').split('|');
      if (cols.indexOf(scope.handle) > -1) return true;
    }
    if (scope.tags.length) {
      var tags = (li.getAttribute('data-tags') || '').split('|');
      for (var i = 0; i < scope.tags.length; i++) {
        if (tags.indexOf(scope.tags[i]) > -1) return true;
      }
    }
    return false;
  }
  function tagParams(chip) {
    if (!chip || !chip.dataset.scopeTag) return '';
    return chip.dataset.scopeTag.split(',').map(function (t) {
      return 'filter.p.tag=' + encodeURIComponent(t.trim());
    }).join('&');
  }
  function activeChip(box) {
    return box.querySelector('.tavern-search__chips .tavern-chip[aria-pressed="true"]');
  }

  function emptyInScope(box, q, chip) {
    var grid = box.querySelector('[data-tavern-live-grid]');
    if (!grid) return;
    var label = chip.textContent.trim();
    var ul = document.createElement('ul');
    ul.className = 'tavern-search__grid';
    ul.setAttribute('role', 'list');
    var li = document.createElement('li');
    li.className = 'tavern-search__none';
    var p = document.createElement('p');
    p.textContent = 'No matches for "' + q + '" in ' + label + '.';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'button';
    btn.setAttribute('data-live-broaden', '');
    btn.textContent = 'Search all products for "' + q + '"';
    li.appendChild(p);
    li.appendChild(btn);
    ul.appendChild(li);
    grid.innerHTML = '';
    grid.appendChild(ul);
    setStatus(box, 'No matches for ' + q + ' in ' + label);
  }

  function render(box, opts) {
    var grid = box.querySelector('[data-tavern-live-grid]');
    if (!grid) return Promise.resolve(null);
    stash(box);
    box.classList.add('is-loading');
    var seq = (box.__tgSeq = (box.__tgSeq || 0) + 1);
    var sep = opts.url.indexOf('?') > -1 ? '&' : '?';
    var fetchUrl = opts.url + sep + (opts.useSectionId ? 'section_id=' : 'sections=') + AUX;
    return fetch(fetchUrl)
      .then(function (r) {
        if (!r.ok) throw new Error('http ' + r.status);
        if (opts.useSectionId) return r.text();
        return r.json().then(function (d) { return d[AUX]; });
      })
      .then(function (html) {
        if (seq !== box.__tgSeq || !box.isConnected) return null;
        if (!html) throw new Error('no fragment');
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var inner = tmp.querySelector('[data-tavern-grid]');
        if (!inner) throw new Error('no grid');
        grid.innerHTML = inner.innerHTML;
        var count = parseInt(inner.getAttribute('data-count') || '0', 10);
        if (opts.scope) {
          count = 0;
          grid.querySelectorAll('li[data-tags]').forEach(function (li) {
            var hit = matches(li, opts.scope);
            li.hidden = !hit;
            if (hit) count++;
          });
        }
        var h = box.querySelector('[data-live-heading]');
        if (h && opts.heading) h.textContent = opts.heading;
        var va = box.querySelector('[data-live-viewall]');
        if (va && opts.view) va.setAttribute('href', opts.view);
        box.classList.remove('is-loading');
        if (opts.scope && count === 0 && opts.q && opts.chip) {
          emptyInScope(box, opts.q, opts.chip);
        } else {
          setStatus(box, opts.status ? opts.status.replace('%n', count) : '');
        }
        return count;
      })
      .catch(function () {
        if (seq !== box.__tgSeq || !box.isConnected) return null;
        box.classList.remove('is-loading');
        if (opts.q) {
          /* keep whatever is on screen; never pretend an error is a result */
          setStatus(box, 'Could not fetch results - press Enter to search.');
        } else {
          restore(box);
        }
        return null;
      });
  }

  function compute(box) {
    if (!box.isConnected) return;
    var input = box.querySelector('.search__input');
    var chip = activeChip(box);
    var q = input ? input.value.trim() : '';
    var su = box.dataset.searchUrl || '/search';
    var pu = box.dataset.suggestUrl || '/search/suggest';
    var clear = box.querySelector('[data-live-clear]');
    if (clear) clear.hidden = !(chip || q.length > 0);
    var scope = scopeOf(chip);
    if (q.length >= 1 && chip && scope) {
      var scopedView = su + '?q=' + encodeURIComponent(q) + (chip.dataset.scopeTag ? '&' + tagParams(chip) : '');
      var url;
      var sectionIdMode;
      if (q.length >= 5 && chip.dataset.scopeTag) {
        /* long enough for the page engine: storefront tag filters apply server-side */
        url = su + '?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last&' + tagParams(chip);
        sectionIdMode = false;
      } else {
        url = pu + '?q=' + encodeURIComponent(q) + '&resources%5Btype%5D=product&resources%5Blimit%5D=10&resources%5Boptions%5D%5Bprefix%5D=last';
        sectionIdMode = true;
      }
      render(box, {
        url: url,
        useSectionId: sectionIdMode,
        scope: scope,
        heading: 'Results for ' + q + ' in ' + chip.textContent.trim(),
        view: scopedView,
        status: '%n results for ' + q + ' in ' + chip.textContent.trim(),
        q: q,
        chip: chip
      });
    } else if (q.length >= 1) {
      render(box, {
        url: pu + '?q=' + encodeURIComponent(q) + '&resources%5Btype%5D=product&resources%5Blimit%5D=10&resources%5Boptions%5D%5Bprefix%5D=last',
        useSectionId: true,
        scope: null,
        heading: 'Results for ' + q,
        view: su + '?q=' + encodeURIComponent(q),
        status: '%n results for ' + q
      });
    } else if (chip) {
      var href = chip.getAttribute('href') || '';
      if (href.charAt(0) !== '/') href = su + '?' + tagParams(chip);
      render(box, {
        url: href,
        useSectionId: false,
        scope: null,
        heading: chip.textContent.trim(),
        view: href,
        status: 'Showing ' + chip.textContent.trim()
      });
    } else {
      box.__tgSeq = (box.__tgSeq || 0) + 1;
      restore(box);
    }
  }

  document.addEventListener('input', function (e) {
    var input = e.target;
    if (!input.classList || !input.classList.contains('search__input')) return;
    var box = input.closest('[data-tavern-live]');
    if (!box) return;
    var clear = box.querySelector('[data-live-clear]');
    if (clear) clear.hidden = !(activeChip(box) || input.value.trim().length > 0);
    clearTimeout(box.__tgTimer);
    box.__tgTimer = setTimeout(function () { compute(box); }, 350);
  });

  document.addEventListener('click', function (e) {
    var broaden = e.target.closest('[data-tavern-live] [data-live-broaden]');
    if (broaden) {
      var bbox = broaden.closest('[data-tavern-live]');
      var bchip = activeChip(bbox);
      if (bchip) bchip.setAttribute('aria-pressed', 'false');
      compute(bbox);
      var binput = bbox.querySelector('.search__input');
      if (binput) binput.focus();
      return;
    }
    var clearBtn = e.target.closest('[data-tavern-live] [data-live-clear]');
    if (clearBtn) {
      var cbox = clearBtn.closest('[data-tavern-live]');
      var cinput = cbox.querySelector('.search__input');
      if (cinput) cinput.value = '';
      cbox.querySelectorAll('.tavern-chip[aria-pressed="true"]').forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
      clearTimeout(cbox.__tgTimer);
      compute(cbox);
      if (cinput) cinput.focus();
      return;
    }
    var chip = e.target.closest('[data-tavern-live] .tavern-search__chips .tavern-chip');
    if (!chip || chip.hasAttribute('data-live-clear')) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button === 1) return;
    var href = chip.getAttribute('href') || '';
    if (href.charAt(0) !== '/' && !chip.dataset.scopeTag) return;
    e.preventDefault();
    var box = chip.closest('[data-tavern-live]');
    var wasActive = chip.getAttribute('aria-pressed') === 'true';
    box.querySelectorAll('.tavern-chip[aria-pressed="true"]').forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
    if (!wasActive) chip.setAttribute('aria-pressed', 'true');
    clearTimeout(box.__tgTimer);
    compute(box);
  });

  document.addEventListener('keydown', function (e) {
    /* Space activates chips that carry role=button */
    if (e.key === ' ' && e.target.closest && e.target.closest('[data-tavern-live] .tavern-search__chips .tavern-chip')) {
      e.preventDefault();
      e.target.click();
      return;
    }
    if (e.key !== 'Escape') return;
    var input = e.target;
    if (!input.classList || !input.classList.contains('search__input')) return;
    var box = input.closest('[data-tavern-live]');
    if (!box) return;
    if (input.value !== '') {
      input.value = '';
    } else {
      var chip = activeChip(box);
      if (chip) chip.setAttribute('aria-pressed', 'false');
    }
    clearTimeout(box.__tgTimer);
    compute(box);
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest ? e.target : null;
    if (!form || !form.closest('[data-tavern-live]')) return;
    var box = form.closest('[data-tavern-live]');
    var chip = activeChip(box);
    if (!chip || !chip.dataset.scopeTag) return; /* plain submit is fine unscoped */
    var input = box.querySelector('.search__input');
    var q = input ? input.value.trim() : '';
    if (q === '') return;
    e.preventDefault();
    window.location.href = (box.dataset.searchUrl || '/search') + '?q=' + encodeURIComponent(q) + '&' + tagParams(chip);
  });

  /* on phones the keyboard hides the grid: lift the panel into view */
  document.addEventListener('focusin', function (e) {
    var input = e.target;
    if (!input.classList || !input.classList.contains('search__input')) return;
    var box = input.closest('[data-tavern-live]');
    if (!box) return;
    if (window.matchMedia('(max-width: 749px)').matches) {
      var behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      box.scrollIntoView({ block: 'start', behavior: behavior });
    }
  });
})();

/* ------------------------------------------------------------
   Gallery lightbox: any [data-lightbox] tile opens a full-size
   viewer with prev/next, Escape, arrow keys and backdrop close.
   One overlay per page, built on first use; focus returns to
   the tile that opened it.
   ------------------------------------------------------------ */
(function () {
  var lb = null;
  var items = [];
  var index = 0;
  var opener = null;

  function build() {
    if (lb) return;
    lb = document.createElement('div');
    lb.className = 'tavern-lb';
    lb.hidden = true;
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', 'Image viewer');
    lb.innerHTML =
      '<img class="tavern-lb__img" alt="">' +
      '<span class="tavern-lb__cap"></span>' +
      '<button type="button" class="tavern-lb__btn tavern-lb__close" aria-label="Close">' +
        '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M3 3l10 10M13 3L3 13" stroke-linecap="round"/></svg>' +
      '</button>' +
      '<button type="button" class="tavern-lb__btn tavern-lb__prev" aria-label="Previous image">' +
        '<svg width="14" height="18" viewBox="0 0 8 12" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M6.5 1l-5 5 5 5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</button>' +
      '<button type="button" class="tavern-lb__btn tavern-lb__next" aria-label="Next image">' +
        '<svg width="14" height="18" viewBox="0 0 8 12" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M1.5 1l5 5-5 5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</button>';
    document.body.appendChild(lb);
    lb.addEventListener('click', function (e) {
      if (e.target === lb) close();
      else if (e.target.closest('.tavern-lb__close')) close();
      else if (e.target.closest('.tavern-lb__prev')) show(index - 1);
      else if (e.target.closest('.tavern-lb__next')) show(index + 1);
    });
  }

  function show(i) {
    if (!items.length) return;
    index = (i + items.length) % items.length;
    var it = items[index];
    var img = lb.querySelector('.tavern-lb__img');
    img.src = it.full;
    img.alt = it.caption || '';
    lb.querySelector('.tavern-lb__cap').textContent = it.caption || '';
    var multi = items.length > 1;
    lb.querySelector('.tavern-lb__prev').hidden = !multi;
    lb.querySelector('.tavern-lb__next').hidden = !multi;
  }

  function open(list, i, from) {
    build();
    items = list;
    opener = from || null;
    lb.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    show(i);
    lb.querySelector('.tavern-lb__close').focus();
  }

  function close() {
    if (!lb || lb.hidden) return;
    lb.hidden = true;
    document.documentElement.style.overflow = '';
    if (opener && opener.isConnected) opener.focus();
    opener = null;
  }

  document.addEventListener('click', function (e) {
    var tile = e.target.closest('[data-lightbox]');
    if (!tile) return;
    e.preventDefault();
    var group = tile.closest('.tavern-cats') || document;
    var tiles = Array.prototype.slice.call(group.querySelectorAll('[data-lightbox]'));
    var list = tiles.map(function (t) {
      return { full: t.getAttribute('data-full'), caption: t.getAttribute('data-caption') || '' };
    });
    open(list, tiles.indexOf(tile), tile);
  });

  document.addEventListener('keydown', function (e) {
    if (!lb || lb.hidden) return;
    if (e.key === 'Escape') { close(); }
    else if (e.key === 'ArrowLeft') { show(index - 1); }
    else if (e.key === 'ArrowRight') { show(index + 1); }
  });
})();

/* ------------------------------------------------------------
   Colour chips (paint ranges: one product, a Colour option).
   Markup: snippets/tavern-colour-chips.liquid, styles:
   tavern-colour-chips.css. Each chip is a button that sets
   Dawn's own select and fires its change event, so Dawn's
   product-info.js does the price, stock, media and address.
   Everything is delegated on document, so editor re-renders
   (shopify:section:load) and Dawn's replaced variant-selects
   need no re-binding; the load hook only re-measures.
   ------------------------------------------------------------ */
(function () {
  var openBoxes = {};   /* box key: true while "Show all" is open */
  var userClosed = {};  /* box key: true after "Show fewer", until the colour changes */
  var focusKey = null;  /* chip to give focus back to after Dawn swaps the picker */
  var focusValue = null;

  function shown(el) { return el.getClientRects().length > 0; }

  function selectFor(box) {
    var wrap = box.closest('.product-form__input');
    return wrap ? wrap.querySelector('select') : null;
  }

  function setOpen(box, on) {
    box.classList.toggle('is-open', on);
    var more = box.querySelector('[data-tavern-colours-more]');
    if (more) more.setAttribute('aria-expanded', on ? 'true' : 'false');
  }

  /* hide "Show all" when every chip already fits in the folded rows */
  function measure(box) {
    if (!box.classList.contains('tg-cc--fold') || box.classList.contains('is-open')) return;
    if (!shown(box)) return;
    var grid = box.querySelector('.tg-cc__grid');
    if (!grid) return;
    box.classList.remove('is-fits');
    if (grid.scrollHeight <= grid.clientHeight + 2) box.classList.add('is-fits');
  }

  /* the chosen colour is never left in a folded row: a ?variant= link (search results
     link straight to a colour), a pick from the list or a narrower screen can put it
     there, so the grid opens. Instant, no animation and no page scroll, so nothing moves
     for reduced-motion visitors. A visitor who pressed "Show fewer" keeps it folded
     until the colour changes. */
  function reveal(box) {
    if (!box.classList.contains('tg-cc--fold') || box.classList.contains('is-open') || box.classList.contains('is-fits')) return;
    var key = box.getAttribute('data-tavern-colours');
    if (userClosed[key] || !shown(box)) return;
    var grid = box.querySelector('.tg-cc__grid');
    var chip = grid && grid.querySelector('.tg-cc__chip[aria-pressed="true"]');
    if (!chip) return;
    var top = chip.offsetTop - grid.scrollTop;
    if (top >= 0 && top + chip.offsetHeight <= grid.clientHeight + 1) return;
    openBoxes[key] = true;
    setOpen(box, true);
    grid.scrollTop = 0;
  }

  function sync(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-tavern-colours]').forEach(function (box) {
      setOpen(box, !!openBoxes[box.getAttribute('data-tavern-colours')]);
      measure(box);
      reveal(box);
    });
  }

  function choose(chip) {
    var box = chip.closest('[data-tavern-colours]');
    var sel = box && selectFor(box);
    if (!sel) return;
    var value = chip.getAttribute('data-value');
    var found = false;
    for (var i = 0; i < sel.options.length; i++) {
      if (sel.options[i].value === value) { found = true; break; }
    }
    if (!found || sel.value === value) return;
    box.querySelectorAll('.tg-cc__chip[aria-pressed="true"]').forEach(function (c) {
      c.setAttribute('aria-pressed', 'false');
      c.tabIndex = -1;
    });
    chip.setAttribute('aria-pressed', 'true');
    chip.tabIndex = 0;
    focusKey = box.getAttribute('data-tavern-colours');
    focusValue = value;
    sel.value = value;
    sel.dispatchEvent(new Event('change', { bubbles: true }));
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var chip = e.target.closest('[data-tavern-colours] .tg-cc__chip');
    if (chip) { choose(chip); return; }
    var more = e.target.closest('[data-tavern-colours-more]');
    if (more) {
      var box = more.closest('[data-tavern-colours]');
      if (!box) return;
      var key = box.getAttribute('data-tavern-colours');
      openBoxes[key] = !box.classList.contains('is-open');
      userClosed[key] = !openBoxes[key];
      setOpen(box, openBoxes[key]);
      if (!openBoxes[key]) {
        var grid = box.querySelector('.tg-cc__grid');
        if (grid) grid.scrollTop = 0;
      }
    }
  });

  /* one tab stop for the whole grid; arrow keys, Home and End move between chips,
     Enter or Space picks (native button behaviour) */
  document.addEventListener('keydown', function (e) {
    var chip = e.target.closest && e.target.closest('[data-tavern-colours] .tg-cc__chip');
    if (!chip) return;
    var k = e.key;
    if (k !== 'ArrowLeft' && k !== 'ArrowRight' && k !== 'ArrowUp' && k !== 'ArrowDown' && k !== 'Home' && k !== 'End') return;
    var chips = Array.prototype.slice.call(chip.parentNode.querySelectorAll('.tg-cc__chip'));
    var i = chips.indexOf(chip);
    var cols = 1;
    while (cols < chips.length && chips[cols].offsetTop === chips[0].offsetTop) cols++;
    var n = i;
    if (k === 'ArrowLeft') n = i - 1;
    else if (k === 'ArrowRight') n = i + 1;
    else if (k === 'ArrowUp') n = i - cols;
    else if (k === 'ArrowDown') n = Math.min(i + cols, chips.length - 1);
    else if (k === 'Home') n = 0;
    else if (k === 'End') n = chips.length - 1;
    if (n < 0 || n >= chips.length || n === i) { e.preventDefault(); return; }
    e.preventDefault();
    chip.tabIndex = -1;
    chips[n].tabIndex = 0;
    chips[n].focus();
  });

  /* keyboard focus on a chip in a folded row opens the grid, so focus is never hidden */
  document.addEventListener('focusin', function (e) {
    var chip = e.target.closest && e.target.closest('[data-tavern-colours] .tg-cc__chip');
    if (!chip) return;
    var box = chip.closest('[data-tavern-colours]');
    if (!box.classList.contains('tg-cc--fold') || box.classList.contains('is-open') || box.classList.contains('is-fits')) return;
    var grid = chip.parentNode;
    if (chip.offsetTop + chip.offsetHeight > grid.clientHeight) {
      openBoxes[box.getAttribute('data-tavern-colours')] = true;
      setOpen(box, true);
      grid.scrollTop = 0;
    }
  });

  /* Dawn swaps the whole variant-selects (chips included) for the server copy after
     every change: put back "Show all", the focus, the backorder note and the photo */
  function productInfoFor(variantId) {
    var hit = null;
    document.querySelectorAll('product-info').forEach(function (pi) {
      if (hit || !shown(pi)) return;
      var input = pi.querySelector('#product-form-' + pi.getAttribute('data-section') + ' input[name="id"]');
      if (input && String(input.value) === String(variantId)) hit = pi;
    });
    return hit;
  }

  function onVariantChange(ev) {
    var d = (ev && ev.data) || {};
    /* a new colour: "Show fewer" no longer holds the fold shut for this section */
    if (d.sectionId) {
      Object.keys(userClosed).forEach(function (k) {
        if (k.indexOf(d.sectionId + '-') === 0) delete userClosed[k];
      });
    } else {
      userClosed = {};
    }
    sync(document);
    if (focusKey !== null) {
      document.querySelectorAll('[data-tavern-colours="' + focusKey + '"]').forEach(function (box) {
        if (!shown(box)) return;
        box.querySelectorAll('.tg-cc__chip').forEach(function (c) {
          if (c.getAttribute('data-value') === focusValue) c.focus({ preventScroll: true });
        });
      });
      focusKey = null;
      focusValue = null;
    }
    var html = d.html;
    if (!d.variant || !html || !html.getElementById) return;
    var pi = productInfoFor(d.variant.id);
    if (!pi) return;
    /* the backorder note follows the colour (it is rendered once on the server) */
    var src = html.getElementById('Tavern-Backorder-' + d.sectionId);
    var dst = pi.querySelector('[id^="Tavern-Backorder-"]');
    if (src && dst) {
      dst.innerHTML = src.innerHTML;
      dst.classList.toggle('hidden', src.classList.contains('hidden'));
    }
    /* a colour with no photo of its own: Dawn keeps the last colour's photo on screen,
       so show the first picture the server put in the gallery instead */
    if (!d.variant.featured_media && typeof pi.updateMedia === 'function') {
      var first = html.querySelector('media-gallery li[data-media-id]');
      var prefix = d.sectionId + '-';
      if (first) {
        var id = first.getAttribute('data-media-id');
        if (id.indexOf(prefix) === 0) id = id.slice(prefix.length);
        try { pi.updateMedia(html, id); } catch (err) { /* Dawn's gallery is optional */ }
      }
    }
  }

  /* PUB_SUB_EVENTS is a const in constants.js (not on window); both load before this file */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, onVariantChange);
  }

  sync(document);
  /* the chip stylesheet sits inside the section and can land after this file runs */
  window.addEventListener('load', function () { sync(document); });
  document.addEventListener('shopify:section:load', function (e) { sync(e.target); });
  var resizeTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () { sync(document); }, 150);
  });
  /* the quick add window and the editor can show a picker after load: measure on first touch */
  document.addEventListener('pointerover', function (e) {
    var box = e.target.closest && e.target.closest('[data-tavern-colours]:not([data-tg-measured])');
    if (!box) return;
    box.setAttribute('data-tg-measured', '');
    measure(box);
    reveal(box);
  }, { passive: true });
})();
